import { render, staticRenderFns } from "./BitcoinPaymentCompletePay.vue?vue&type=template&id=d5b57870&"
import script from "./BitcoinPaymentCompletePay.vue?vue&type=script&lang=js&"
export * from "./BitcoinPaymentCompletePay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports